export const NONE_PACKAGE = 0
export const PACKAGE_SILVER = 1
export const PACKAGE_GOLD = 2
export const PACKAGE_RUBY = 3
export const PACKAGE_DIAMOND = 4

export const StatusReferral = {
    NEW: 0,
    SUCCESS: 1,
    ERROR: 2,
    REJECTED: 3,
    PROCESSED: 4,
    DUPLICATE_CASE: 5,
    INSUFFICIENT_DAY_CASE: 6,
    NOT_REFERRAL_CASE: 7,
}

export const StatusStakedReferral = {
    BONUS_SUCCESS: 1,
    BONUS_FAIL_WITHOUT_MONEY: 2,
    BONUS_NONE: 3,
}

export const MINIMUM_BONUS_AMOUNT = 5000
export const CONNECT = 'isConnect'
export const MAXIMUM_DECIMALS = 4

export const BSC_SCAN_HASH_URL = 'https://bscscan.com/tx/'
export const SCORE_API = 'https://score-api.wanakafarm.tech/graphql'
